<template>
    <form class="product-page-cart" @submit.prevent="onSubmit">

        <div class="product-page-cart__bottom">

            <div class="product-page-cart__prices">
                <div class="product-page-cart__vat" v-if="!isComplect && isVatIncluded">
                    В цену включен НДС 20%
                </div>
                <div class="product-page-cart__prices-item product-page-cart__prices-item--old" v-if="prices.old" v-html="prices.old"></div>
                <div class="product-page-cart__prices-item" v-html="prices.current" style="margin-bottom: 0;"></div>
                <div class="product-page-cart__item-status-available" v-if="(!isComplect || product.CAN_BUY) && product.CATALOG_QUANTITY > 0">В наличии</div>
                <div class="product-page-cart__item-status-not-available" v-else>Под заказ</div>

            </div>

            <template v-if="(!isComplect || product.CAN_BUY) && product.CATALOG_QUANTITY > 0">
                <div class="product-page-cart__counter">
                    <quantity-input v-model="quantity" />
                </div>

                <div class="product-page-cart__btn">
                    <div class="product-page-cart__info" v-if="!catalogInStock">
                        <span>Уточняйте наличие у менеджера</span>
                    </div>
                    <button class="btn btn-main btn-block" :disabled="productInCart">
                        <template v-if="productInCart">В корзине</template>
                        <template v-else>В корзину</template>
                    </button>
                </div>
            </template>
            <template v-else>
                 <a data-toggle="modal" data-target="#notifyAvailable" class="btn btn-block btn-main btn-nodify-available">Заказать</a>
            </template>

        </div>

        <div class="product-page-cart__error" v-if="error">
            {{ error }}
        </div>

        <transition name="fade">
            <div class="product-page-cart__spinner" v-if="isLoading">
                <div class="spinner-border text-main" role="status" />
            </div>
        </transition>

    </form>
</template>

<script>
import { EVENT_ADD_TO_CART } from '../../services/event-bus/event-types';

import QuantityInput from '../common/quantity-input';
import { globalErrorHandler } from '../../services/error-handling';

const { eventBus } = window.specialtyApp;

export default {
    name: 'equipment-page-controls',
    inject: ['$basketService'],
    components: {
        QuantityInput,
    },
    data() {
        return {
            quantity: null,
            isLoading: false,
            oldQuantity: 1,
            productChangeProcess: false,

            error: null,
        };
    },
    props: {
        product: {
            type: Object,
            required: true,
        },

        purchaseAllowed: {
            type: Boolean,
            required: true,
        },

        detailUrl: {
            type: String,
        },

        isComplect: {
            type: Boolean,
            default: false,
        },

        isVatIncluded: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        onSubmit() {
            this.addToBasket();
        },

        async addToBasket() {
            if (this.purchaseAllowed) {
                this.isLoading = true;
                this.error = null;

                try {
                    const { data: { data, message } } = await this.$basketService.addToBasket(
                        this.product.ID,
                        this.quantity,
                    );

                    if (message) {
                        this.error = message;
                        return;
                    }

                    eventBus.$emit(EVENT_ADD_TO_CART, {
                        basketData: data,
                        quantity: this.quantity,
                        type: 'equipment',
                        actualItem: this.product,
                    });
                } catch (error) {
                    globalErrorHandler(error);
                } finally {
                    this.isLoading = false;
                }
            } else {
                $('#notify_url').val(this.detailUrl);
                $('#notifyAvailable').modal('show');
            }
        },

        async updateInBasket() {
            this.isLoading = true;
            try {
                await this.$basketService.updateInBasket(this.productInCart.ID, this.quantity);
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        updateQuantityHandler: BX.debounce(function handler() {
            this.updateInBasket();
        }, 500),

        quantityWatchHandler(newQuantity, oldQuantity) {
            if (newQuantity === '') {
                this.oldQuantity = oldQuantity;
                return;
            }

            if (
                newQuantity === oldQuantity
                || !this.productInCart
                || this.productChangeProcess
            ) {
                return;
            }

            this.updateQuantityHandler();
        },
    },
    computed: {
        prices() {
            const price = this.product?.CURRENT_PRICE;
            return {
                current: price?.PRINT_DISCOUNT_VALUE,
                old: price?.PRINT_VALUE !== price?.PRINT_DISCOUNT_VALUE ? price?.PRINT_VALUE : null,
            };
        },
        basketRows() {
            return Object.values(this.$basketService.state.basketData?.BASKET?.ITEMS || {});
        },
        productInCart() {
            return this.basketRows.find((basketItem) => `${basketItem.PRODUCT_ID}` === `${this.product.ID}`);
        },
        catalogInStock() {
            const quantity = this.product?.CATALOG_QUANTITY;
            return parseInt(quantity, 10) > 0;
        },

    },
    watch: {
        quantity: 'quantityWatchHandler',
        productInCart: {
            immediate: true,
            deep: true,
            handler(newProduct) {
                this.productChangeProcess = true;

                if (newProduct) {
                    this.quantity = newProduct.QUANTITY;
                } else {
                    this.quantity = 1;
                }

                this.$nextTick(() => {
                    this.productChangeProcess = false;
                });
            },
        },
    },
};
</script>
